module.exports = __webpack_public_path__ + "img/ais-vision-ai.99d73f91.jpg";